<template>
  <div class="main container-fluid tools-page">
    <header class="tools-hero">
      <div>
        <h4 class="tools-hero__title mb-1">Инструменты</h4>
        <p class="tools-hero__subtitle mb-0">Выберите инструмент для запуска рабочих задач</p>
      </div>
    </header>

    <section class="px-3 pb-4">
      <div class="tools-surface">
        <div class="tools-surface__head">
          <span class="tools-surface__title">Доступные инструменты</span>
          <small class="tools-surface__hint">Сейчас доступно: 2</small>
        </div>

        <div class="tools-grid">
          <router-link to="/tools/wordpress-deployment" class="tool-card tool-card-link tool-card--primary">
            <div class="tool-card__icon-wrap">
              <img src="@/assets/icons/wordpress.png" alt="Wordpress" class="tool-card__icon" />
            </div>

            <div class="tool-card__body">
              <div class="tool-card__eyebrow">Автоматизация</div>
              <h6 class="tool-card__title mb-1">Создание и настройка WordPress</h6>
              <p class="tool-card__description mb-0">
                Запуск автоматического deployment WordPress, live-логи установки и итоговые реквизиты сайта.
              </p>
            </div>

            <div class="tool-card__tail">
              <span class="tool-card__badge">Открыть</span>
              <i class="bi bi-arrow-right-short"></i>
            </div>
          </router-link>

          <router-link to="/tools/wordpress-concept" class="tool-card tool-card-link tool-card--primary">
            <div class="tool-card__icon-wrap">
              <i class="bi bi-lightbulb"></i>
            </div>

            <div class="tool-card__body">
              <div class="tool-card__eyebrow">Мастер-процесс</div>
              <h6 class="tool-card__title mb-1">Разработка концепции сайта</h6>
              <p class="tool-card__description mb-0">
                Поэтапная генерация концепций через AI, выбор основной концепции и переход к следующему шагу.
              </p>
            </div>

            <div class="tool-card__tail">
              <span class="tool-card__badge">Открыть</span>
              <i class="bi bi-arrow-right-short"></i>
            </div>
          </router-link>

          <article class="tool-card tool-card--coming-soon" aria-disabled="true">
            <div class="tool-card__icon-wrap tool-card__icon-wrap--ghost">
              <i class="bi bi-tools"></i>
            </div>

            <div class="tool-card__body">
              <div class="tool-card__eyebrow">Скоро</div>
              <h6 class="tool-card__title mb-1">Дополнительные утилиты</h6>
              <p class="tool-card__description mb-0">
                Планируем добавить инструменты диагностики и обслуживания публикационных контуров.
              </p>
            </div>

            <div class="tool-card__tail">
              <span class="tool-card__badge tool-card__badge--muted">В разработке</span>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ToolsPage',
}
</script>

<style scoped>
.tools-page {
  min-height: 100%;
  padding-top: 10px;
  background:
    radial-gradient(circle at 2% 3%, rgba(66, 153, 225, 0.2), transparent 36%),
    radial-gradient(circle at 98% 2%, rgba(56, 189, 248, 0.18), transparent 32%),
    #f3f7ff;
}

.tools-hero {
  margin: 0 20px 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #10305f 0%, #1b4f93 60%, #1e67b7 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 40px rgba(16, 48, 95, 0.22);
}

.tools-hero__title {
  font-weight: 800;
  letter-spacing: 0.01em;
}

.tools-hero__subtitle {
  color: rgba(232, 242, 255, 0.92);
  font-size: 13px;
}

.tools-surface {
  border-radius: 14px;
  border: 1px solid #dce7fa;
  background: #fff;
  padding: 12px;
}

.tools-surface__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.tools-surface__title {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  border: 1px solid #d8e5fb;
  background: #eff5ff;
  color: #3b5690;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.tools-surface__hint {
  color: #5f7698;
  font-size: 12px;
  font-weight: 700;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
  gap: 12px;
}

.tool-card {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #dce7fa;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 8px 18px rgba(24, 55, 100, 0.08);
}

.tool-card-link {
  text-decoration: none;
  color: inherit;
  transition: transform 0.16s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.tool-card-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(24, 55, 100, 0.14);
  border-color: #bed5f7;
}

.tool-card__icon-wrap {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #eef5ff;
  border: 1px solid #d7e4fa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 46px;
}

.tool-card__icon-wrap--ghost {
  background: #f6f8fc;
  color: #6782a8;
  font-size: 18px;
  border-color: #e2e8f4;
}

.tool-card__icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
}

.tool-card__icon-wrap:not(.tool-card__icon-wrap--ghost) i {
  font-size: 22px;
  color: #3b6ba5;
  line-height: 1;
}

.tool-card__body {
  min-width: 0;
}

.tool-card__eyebrow {
  color: #5d769c;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}

.tool-card__title {
  color: #1f2d45;
  font-weight: 700;
  font-size: 15px;
}

.tool-card__description {
  color: #6c7a92;
  font-size: 13px;
  line-height: 1.35;
}

.tool-card__tail {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #3f6fa8;
  font-size: 22px;
}

.tool-card__badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid #c7dcff;
  background: #eaf3ff;
  color: #2d5d96;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  line-height: 1;
}

.tool-card__badge--muted {
  border-color: #dfe6f3;
  background: #f4f7fc;
  color: #667995;
}

.tool-card--coming-soon {
  background: linear-gradient(180deg, #ffffff 0%, #fafcff 100%);
  box-shadow: none;
}

@media (max-width: 992px) {
  .tools-hero {
    margin: 0 12px 12px;
    padding: 12px;
  }

  .tool-card {
    grid-template-columns: auto 1fr;
  }

  .tool-card__tail {
    grid-column: 1 / -1;
    justify-content: flex-start;
    margin-top: 2px;
    font-size: 18px;
  }
}

@media (max-width: 700px) {
  .tools-surface__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .tools-grid {
    grid-template-columns: 1fr;
  }
}
</style>
